<template>
    <div class="xl:container-1280 xl:mx-auto">

        <header class="px-14 pt-1 pb-1">
            <div class="flex flex-col justify-center lg:flex-row lg:justify-between">
                <div id="brand" class="flex flex-col items-center sm:flex-row justify-center mt-5 sm:divide-x-2 sm:divide-white">
                    <router-link to="/" title="Intranet MPE-TO - Pagina inicial" class="sm:mt-4 sm:mr-9">
                        <img src="../../assets/logo.png" alt="Logo MPE-TO" class="w-52">
                    </router-link>

                    <div id="brand-title" class="text-white p-3 sm:p-6 sm:pl-9">
                        <h1 class="text-lg text-center sm:text-left lg:text-2xl xl:text-4xl font-semibold">Portal Conecta MPTO</h1>
                        <p class="text-base text-center sm:text-left lg:text-2xl font-light">Informação e Interatividade</p>
                    </div>
                </div>
                <div>
                    <div class="my-2 sm:my-5 text-3xl text-center lg:text-right space-x-3 text-white">
                        <a href="https://facebook.com/MPETocantins" title="Facebook" tabindex="-1">
                            <i class="fab fa-facebook-square"></i>
                        </a>
                        <a href="https://twitter.com/MPETocantins" title="Twitter" tabindex="-1">
                            <i class="fab fa-twitter"></i>
                        </a>
                        <a href="https://instagram.com/MPETocantins" title="Instagram" tabindex="-1">
                            <i class="fab fa-instagram"></i>
                        </a>
                        <a href="https://youtube.com/MPETocantins" title="Youtube" tabindex="-1">
                            <i class="fab fa-youtube"></i>
                        </a>
                        <a href="https://www.flickr.com/photos/mpetocantins/albums" title="Flickr" tabindex="-1">
                            <i class="fab fa-flickr"></i>
                        </a>
                    </div>
                    <form id="search-form" action="/search" class="flex justify-center">
                        <div class="flex items-center p-1 bg-white w-max">
                            <i class="text-lg text-gray-400 fas fa-search mr-1"></i>
                            <input class="text-lg w-52 h-5" name="terms" type="text">
                        </div>
                    </form>
                </div>
            </div>

            <main-menu />

        </header>

        <div class="bg-white bg-opacity-60">
            <slot></slot>            
        </div>

        <footer class="p-7 text-gray-400 bg-gray-700">
            <div class="flex flex-col xl:flex-row justify-end items-center space-y-3 xl:space-y-0">              
                <!--< div class="text-center text-3xl text-right space-x-3 text-white mr-5">
                    <a href="https://facebook.com/MPETocantins" title="Facebook" tabindex="-1">
                        <i class="fab fa-facebook-square"></i>
                    </a>
                    <a href="https://twitter.com/MPETocantins" title="Twitter" tabindex="-1">
                        <i class="fab fa-twitter"></i>
                    </a>
                    <a href="https://instagram.com/MPETocantins" title="Instagram" tabindex="-1">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a href="https://youtube.com/MPETocantins" title="Youtube" tabindex="-1">
                        <i class="fab fa-youtube"></i>
                    </a>
                    <a href="https://www.flickr.com/photos/mpetocantins/albums" title="Flickr" tabindex="-1">
                        <i class="fab fa-flickr"></i>
                    </a>
                </div> -->

                  <!-- <div class="flex-auto text-center">
                    <p>Endereço</p>
                    <p>202 NORTE, AV. LO 4, CONJ. 1, Lotes 5 e 6</p>
                    <p>Plano Diretor Norte - CEP 77.006-2018 - Palmas - TO</p>
                </div>
                <div class="flex-auto text-center">
                    <p>Horário de atendimento</p>
                    <p>Segunda à Sexta</p>
                    <p>09h00 às 12h00 e 14h00 às 18h00</p>
                </div>
                <div class="flex-auto text-center">
                    <p>Telefone</p>
                    <p>(63) 3216-7600</p>
                </div> -->

                <!-- <div class="text-right">
                    <div class="image-box w-56" style="height: 103px;">
                        <img src="../../assets/logo.png" title="Ministério Público Estadual do Tocantins" class="w-full">
                    </div>                    
                </div> -->
            </div>
        </footer>

    </div>
</template>

<script>


import MainMenu from './MainMenu.vue'

export default {
    components: {
        MainMenu
    }
}
</script>

<style lang="css" scoped>

header, footer
{ background: url(../../assets/images/bg-cube-blue.png) repeat; }


#logo
{ background: url(../../assets/logo.png) no-repeat; }

/*footer
{ background: #4e4e4e;  }
*/
</style>